import type {
	ForOnboardingUser,
	OnboardingAnswersPayload,
	OnboardingQuestions
} from 'core'

import { HTTPClient, HTTPMethods } from './http_client'

export type PossibleAnswerDTO = {
	id: number
	question_id: number
	content: string
	position: number
}

export type OnboardingQuestionsDTO = {
	id: number
	title: string
	content: string
	active: boolean
	possible_answers: PossibleAnswerDTO[]
	position: number
}

export type OnboardingAnswersDTO = {
	question_id: number
	question_option_id: number
}

export type OnboardingAnswersPayloadDTO = {
	onboarding_answers: OnboardingAnswersDTO[]
	plan_id: string
}

export class OnboardManager implements ForOnboardingUser {
	readonly client = new HTTPClient()

	async getOnboardingQuestions() {
		const response = await this.client.fetch<OnboardingQuestionsDTO[]>(
			`/authv2/accounts/api/v1/onboarding_questions`
		)

		if (response.error) return { error: response.error }

		return {
			data: response.data!.map(this.formatOnboardingQuestionsData)
		}
	}

	completeOnboardProcess(payload: OnboardingAnswersPayload) {
		if (!payload) {
			return Promise.reject(new Error('Payload is required'))
		}

		return this.client.fetch<string, OnboardingAnswersPayloadDTO>(
			`/authv2/home/api/v1/get_started`,
			{
				method: HTTPMethods.Post,
				data: {
					onboarding_answers: payload.onboardingAnswers.map(answer => ({
						question_id: answer.questionId,
						question_option_id: answer.questionOptionId
					})),
					plan_id: payload.planId
				}
			}
		)
	}

	private formatOnboardingQuestionsData = (
		question: OnboardingQuestionsDTO
	): OnboardingQuestions => ({
		id: question.id,
		title: question.title,
		content: question.content,
		active: question.active,
		possibleAnswers: question.possible_answers.map(answer => ({
			id: answer.id,
			questionId: answer.question_id,
			content: answer.content,
			position: answer.position
		})),
		position: question.position
	})
}

export class OnboardManagerMock implements ForOnboardingUser {
	getOnboardingQuestions() {
		return Promise.resolve({
			data: [
				{
					id: 0,
					title: 'AI Experience',
					content: 'How much experience do you have with AI?',
					active: true,
					possibleAnswers: [
						{
							id: 0,
							questionId: 0,
							content: 'None',
							position: 0
						},
						{
							id: 1,
							questionId: 0,
							content: 'A little Bit',
							position: 1
						},
						{
							id: 3,
							questionId: 0,
							content: 'Im kind of proud of myself',
							position: 3
						}
					],
					position: 0
				},
				{
					id: 1,
					title: 'Crypto Experience',
					content: 'How much experience do you have with Solana/Crypto?',
					active: true,
					possibleAnswers: [
						{
							id: 4,
							questionId: 0,
							content: 'Im a newbie',
							position: 0
						},
						{
							id: 6,
							questionId: 0,
							content: 'Im a ninja',
							position: 2
						},
						{
							id: 5,
							questionId: 0,
							content: 'I know somme stuff',
							position: 1
						}
					],
					position: 1
				}
			]
		})
	}

	completeOnboardProcess(payload: OnboardingAnswersPayload) {
		if (!payload) {
			return Promise.reject(new Error('Payload is required'))
		}

		return Promise.resolve({
			data: 'onboarding user answers saved'
		})
	}
}
